export enum DummyClassroomIds {
  CLASSROOM_1 = 1,
}

export enum DummyUserIds {
  ADMIN = 1,
  TEACHER = 3,
}
